import { Route } from '@angular/router';
import { crmLandingRoute } from './crm-route.helpers';

const ADVISORS_CRUMB = { id: 'advisors', label: 'Asesores' };

export const CRM_ADVISORS_ROUTES: Route[] = [
  crmLandingRoute({
    path: 'advisors/advisors-managers/advisors-managers',
    moduleId: 'advisors',
    activeMenubarId: 'adv-list',
    title: 'Asesores y gerentes',
    breadcrumbs: [
      ADVISORS_CRUMB,
      { id: 'advisors-managers', label: 'Asesores y gerentes' },
    ],
    loadComponent: () =>
      import(
        '../pages/advisors/advisors-managers/advisors-managers/advisors-managers.component'
      ).then((m) => m.AdvisorsManagersComponent),
  }),
  crmLandingRoute({
    path: 'advisors/real-estate-agencies/real-estate-agencies',
    moduleId: 'advisors',
    activeMenubarId: 'adv-agencies',
    title: 'Inmobiliarias',
    breadcrumbs: [
      ADVISORS_CRUMB,
      { id: 'real-estate-agencies', label: 'Inmobiliarias' },
    ],
    loadComponent: () =>
      import(
        '../pages/advisors/real-estate-agencies/real-estate-agencies/real-estate-agencies.component'
      ).then((m) => m.RealEstateAgenciesComponent),
  }),
  crmLandingRoute({
    path: 'advisors/reports/advisors',
    moduleId: 'advisors',
    activeMenubarId: 'adv-rep-advisors',
    title: 'Asesores',
    breadcrumbs: [
      ADVISORS_CRUMB,
      { id: 'reports', label: 'Reportes' },
      { id: 'advisors-report', label: 'Asesores' },
    ],
    loadComponent: () =>
      import(
        '../pages/advisors/reports/advisors/advisors-report.component'
      ).then((m) => m.AdvisorsReportComponent),
  }),
  crmLandingRoute({
    path: 'advisors/reports/managers',
    moduleId: 'advisors',
    activeMenubarId: 'adv-rep-managers',
    title: 'Gerentes',
    breadcrumbs: [
      ADVISORS_CRUMB,
      { id: 'reports', label: 'Reportes' },
      { id: 'managers-report', label: 'Gerentes' },
    ],
    loadComponent: () =>
      import(
        '../pages/advisors/reports/managers/managers-report.component'
      ).then((m) => m.ManagersReportComponent),
  }),
  crmLandingRoute({
    path: 'advisors/reports/agencies',
    moduleId: 'advisors',
    activeMenubarId: 'adv-rep-agencies',
    title: 'Inmobiliarias',
    breadcrumbs: [
      ADVISORS_CRUMB,
      { id: 'reports', label: 'Reportes' },
      { id: 'agencies-report', label: 'Inmobiliarias' },
    ],
    loadComponent: () =>
      import(
        '../pages/advisors/reports/agencies/agencies-report.component'
      ).then((m) => m.AgenciesReportComponent),
  }),
];
